import React, { useEffect, useState, useMemo } from "react";
import BasicTable from "../../maincomponent/reacttable/table";
import { basetime } from "../../../text/apidata";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch ,useSelector } from "react-redux";
import "../../style/page/tabs/basetime.scss";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import BaseTimeForm from "../../form/tabs/basetimeform";
import {basetimeedit,basetimeid} from "../../redux/reducer/counterslice"
function BaseTime(props) {
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState();
  const activebtf = useSelector((state) => state.counter.basetimeedit);
  const editdoctorid = useSelector((state) => state.counter.edituserdoctorid);

const[form,setform]=useState(false)
const dispatch = useDispatch();
const btid=useDispatch();
  const doctor = useNavigate();
  useEffect(() => {
    props.loaderchange("true");
    axios({
      method: "get",
      url: basetime,
      params: {
        doctor: editdoctorid,
        page: dtpageindex,
        page_size: dtpagesize,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        const numAscending = [...res.data.data].sort((a, b) => a.day - b.day);
        setdatacount(res.data.data_count)

        settableheaderdata(numAscending);
        props.loaderchange("false");
      })
      .catch((error) => {
        props.loaderchange("false");
          // setdtPageindex(dtpageindex-1)
          props.popupalert("true");
          props.popuptext("No Data Available");
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
      });
  }, [dtpageindex, dtpagesize, editdoctorid]);

  // console.log(editdoctorid);
  const dropdownhandlechange = (e) => {

    setform(true)

    if (e) {
      // specialitynav("/SpecialityForm");
       dispatch(basetimeedit("btfactive"));
      btid(basetimeid(e));
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Day",
        accessor: "",
        Cell: (row) => {

          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="basetime"
                  data-tooltip-content={
                    row.row.original.day == 0
                      ? "Monday"
                      : row.row.original.day == 1
                      ? "Tuesday"
                      : row.row.original.day == 2
                      ? "Wednesday"
                      : row.row.original.day == 3
                      ? "Thursday"
                      : row.row.original.day == 4
                      ? "Friday"
                      : row.row.original.day == 5
                      ? "Saturday"
                      : row.row.original.day == 6
                      ? "Sunday"
                      : ""
                  }
                >
                  {row.row.original.day == 0
                    ? "Monday"
                    : row.row.original.day == 1
                    ? "Tuesday"
                    : row.row.original.day == 2
                    ? "Wednesday"
                    : row.row.original.day == 3
                    ? "Thursday"
                    : row.row.original.day == 4
                    ? "Friday"
                    : row.row.original.day == 5
                    ? "Saturday"
                    : row.row.original.day == 6
                    ? "Sunday"
                    : ""}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "StartTime",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="basetime"
                  data-tooltip-content={String(row.row.original.start_time)}
                >
                  {String(row.row.original.start_time)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "EndTime",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="basetime"
                  data-tooltip-content={String(row.row.original.end_time)}
                >
                  {String(row.row.original.end_time)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Duration",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="basetime"
                  data-tooltip-content={String(row.row.original.duration)}
                >
                  {String(row.row.original.duration)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original)
          //settablevalue(row.row.original)

          return (
            <>
              {/* <FormControl variant="standard" sx={{ minWidth: 60 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  disableUnderline
                  // value={age}
                  onChange={(e) => dropdownhandlechange(row.row.original.id)}
                  label="Age"
                  defaultValue="none"
                  style={{
                    fontSize: "12px",
                  }}
                >
                  <MenuItem value="none" disabled style={{ display: "none" }}>
                    Select
                  </MenuItem>
                  <MenuItem value={1}>Edit</MenuItem>
                </Select>
              </FormControl> */}
                            <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
                {/* <button type="button" class="btn btn-danger btn-sm delete">
                  <i class="bi bi-trash3"></i> Delete
                </button> */}
              </div>

            </>
          );
        },
      },

    ],
    []
  );

  const routeback = () => {
    doctor("/Doctor");
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };


  const loaderchangebt = (arg)=>{
    props.loaderchange(arg)
    }
  const popupalertbt =(arg)=>{
    props.popupalert(arg)
  }
  const popuptextbt =(arg)=>{
    props.popuptext(arg)
    
  }
  
  return (
    <>
     <div className="maincontainer_base">
        <div className="basetime_v">
          <div className="table-content-basetime">
            <div className="table-basetime">
              <BasicTable
                columns={columns}
                data={tableheaderdata}
                pagesize={pagesize}
                pageindex={pageindex}
                dtpagesize={dtpagesize}
                dtpageindex={dtpageindex}
                datacount={datacount}
              />
            </div>
          </div>
        </div>
        <ReactTooltip
          id="basetime"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
    </>
  );
}

export default BaseTime;
